import { getParticipantName } from "../../utils/participantDisplay";

// Pure client-side filtering/sorting for the conversation-progress admin
// list. The backend only supports conversation/student/isForMe/limit query
// params, so search/status/type/date range are all applied here.
export function filterProgress(progresses, { search, status, typeId, dateFrom, dateTo } = {}) {
    const term = (search || "").trim().toLowerCase();

    return progresses.filter((progress) => {
        if (term) {
            const conversationName = progress.conversationId?.name || "";
            const haystack = `${conversationName} ${getParticipantName(progress)}`.toLowerCase();
            if (!haystack.includes(term)) return false;
        }

        if (status === "finished" && progress.isFinished !== 1) return false;
        if (status === "pending" && progress.isFinished === 1) return false;

        if (typeId != null && typeId !== "" && progress.conversationId?.typeId?.id !== typeId) return false;

        if (dateFrom || dateTo) {
            if (!progress.dAdd) return false;
            const addedAt = progress.dAdd.slice(0, 10); // ISO date prefix - safe to compare lexicographically
            if (dateFrom && addedAt < dateFrom) return false;
            if (dateTo && addedAt > dateTo) return false;
        }

        return true;
    });
}

export function sortProgress(progresses, sortKey) {
    const sorted = [...progresses];
    if (sortKey === "oldest") sorted.reverse();
    // "newest" (default) is already the order the backend returns.
    return sorted;
}
